export default __webpack_public_path__ + "static/media/2930 knife block B top.43966e2e.png";